import { motion } from "framer-motion";

const PARTNERS = [
  {
    id: "ihub",
    name: "i-Hub Gujarat, Student Startup & Innovation Hub, Government of Gujarat",
    src: "/partners/ihub.png",
    className: "h-8 sm:h-9",
  },
  {
    id: "iitrpr",
    name: "IIT Ropar, Indian Institute of Technology Ropar",
    src: "/partners/iitrpr.png",
    className: "h-12 sm:h-14",
  },
  {
    id: "nielit",
    name: "NIELIT, National Institute of Electronics & IT, MeitY",
    src: "/partners/nielit.png",
    className: "h-12 sm:h-14",
  },
  {
    id: "stpinext",
    name: "STPINEXT Initiatives, Software Technology Parks of India, MeitY",
    src: "/partners/stpinext.png",
    className: "h-7 sm:h-8",
  },
  {
    id: "gsc",
    name: "GSC Golden State Capital, Singapore",
    src: "/partners/gsc.png",
    className: "h-6 sm:h-7",
  },
  {
    id: "inlighten",
    name: "Inlighten Leadership, London",
    src: "/partners/inlighten.png",
    className: "h-8 sm:h-9",
  },
];

export default function TrustStrip() {
  return (
    <section
      data-testid="trust-strip"
      aria-label="Ecosystem partners"
      className="border-b border-[rgba(212,175,55,0.15)] bg-[#070E1B] py-10 sm:py-12"
    >
      <motion.p
        initial={{ opacity: 0 }}
        whileInView={{ opacity: 1 }}
        viewport={{ once: true }}
        transition={{ duration: 0.8 }}
        className="text-center font-mono-alt text-[10px] uppercase tracking-[0.34em] text-[#64748B]"
      >
        In Ecosystem Partnership With
      </motion.p>
      <div className="mx-auto mt-8 flex max-w-4xl flex-wrap items-center justify-center gap-x-14 gap-y-7 px-5 sm:gap-x-20">
        {PARTNERS.map((p, i) => (
          <motion.img
            key={p.id}
            src={p.src}
            alt={p.name}
            title={p.name}
            data-testid={`trust-logo-${p.id}`}
            initial={{ opacity: 0, y: 14 }}
            whileInView={{ opacity: 0.6, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.8, delay: i * 0.12, ease: [0.22, 1, 0.36, 1] }}
            whileHover={{ opacity: 1 }}
            className={`${p.className} w-auto cursor-default transition-opacity duration-500`}
          />
        ))}
      </div>
    </section>
  );
}
